import { useEffect, useState } from "react";
import ValidationUtils from "./ValidationUtils";

const baseState = {
  processing: false,
  message: "",
  overlay: false,
  error: false,
};

const { isDefined } = ValidationUtils;
const PROCESSING_EVENT = "customProcessingEvent";

let sharedState = { ...baseState };

export const updateProcessingState = (
  { processing, message, overlay, error, reset, delay = 0 } = { delay: 0 }
) => {
  const newState = { ...baseState };
  if (!reset) {
    isDefined(processing) && (newState.processing = processing);
    isDefined(message) && (newState.message = message);
    isDefined(overlay) && (newState.overlay = overlay);
    isDefined(error) && (newState.error = error);
  }

  const updateState = () => {
    sharedState = newState;
    document.dispatchEvent(new CustomEvent(PROCESSING_EVENT, { bubbles: true }));
  };

  delay ? setTimeout(updateState, delay) : updateState();
};

export const useProcessingState = () => {
  const [state, setState] = useState({ ...sharedState });
  const updateState = () => setState({ ...sharedState });

  useEffect(() => {
    document.addEventListener(PROCESSING_EVENT, updateState);
    return () => {
      document.removeEventListener(PROCESSING_EVENT, updateState);
    };
  }, []);

  return state;
};

// dev tools
const toggleProcessingState = (props) => {
  if (props.reset) {
    updateProcessingState({ ...baseState });
  } else {
    updateProcessingState({ ...props });
  }
};

window.toggleProcessingState = toggleProcessingState;
window.resetProcessingState = () => updateProcessingState({ ...baseState });
window.overlayProcessingState = () => updateProcessingState({ processing: true, overlay: true });
window.startProcessing = () => updateProcessingState({ processing: true });
